export default {
  setMenuOption: (state, payload) => (state.menuOption = payload),
  setSubMenuOption: (state, payload) => (state.subMenuOption = payload),
  setNotificationBellAmount: (state, payload) =>
    (state.notificationBellAmount = payload),
  setLastTotalNotificationCount: (state, payload) =>
    (state.lastTotalNotificationCount = payload),
  setCurrentTotalNotificationCount: (state, payload) =>
    (state.currentTotalNotificationCount = payload),
  setUpdatedRoute: (state, payload) => (state.updatedRoute = payload)
}
